(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["glgs-phone-choice"] && !Shopify.designMode) return;
  try {
    (() => {
    const dialog = document.getElementById('GLGSPhoneChoice');
    if (!dialog || typeof dialog.showModal !== 'function' || dialog.dataset.initialized) return;
    dialog.dataset.initialized = 'true';
    let opener = null;
    let suppressEscapeKeyup = false;
    const businessNumbers = new Map([
      ['3307476139', { destination: '+13307476139', label: '330-747-6139' }],
      ['8004776275', { destination: '+18004776275', label: '1-800-477-6275' }],
    ]);
    const numberFromText = (value) => {
      const digits = value.replace(/\D/g, '');
      const national = digits.length === 11 && digits.startsWith('1') ? digits.slice(1) : digits;
      return businessNumbers.get(national);
    };
    const businessNumber = (link) => {
      const match = (link.getAttribute('href') || '').trim().match(/^(tel|sms):([+\d().\s-]+)$/i);
      if (!match) return false;
      return numberFromText(match[2]);
    };
    const phoneLinks = (root) => Array.from(root.querySelectorAll('a[href]')).filter((link) => businessNumber(link) && !dialog.contains(link));
    const enhance = (root) => {
      const links = phoneLinks(root);
      links.forEach((link) => {
        if (link.dataset.glgsPhoneChoice) return;
        const phone = businessNumber(link);
        const isText = /^sms:/i.test(link.getAttribute('href'));
        const helpCard = link.closest('.glgs-help-card');
        const row = link.closest('li');
        const displayedNumber = /^[+\d().\s-]+$/.test(link.textContent.trim()) && numberFromText(link.textContent) === phone;
        const simpleTextRow = row && row.children.length === 2 && row.firstElementChild.tagName === 'STRONG' && !row.firstElementChild.children.length && /^text:$/i.test(row.firstElementChild.textContent.trim()) && row.lastElementChild === link && !link.children.length && displayedNumber && Array.from(row.childNodes).every((node) => node === row.firstElementChild || node === link || (node.nodeType === Node.TEXT_NODE && !node.textContent.trim()));
        const duplicateRow = isText && simpleTextRow && row.parentElement && phoneLinks(row.parentElement).some((other) => other !== link && businessNumber(other) === phone && /^tel:/i.test(other.getAttribute('href')) && other.closest('li') !== row);
        if (isText && ((helpCard && phoneLinks(helpCard).some((other) => businessNumber(other) === phone && /^tel:/i.test(other.getAttribute('href')))) || duplicateRow)) {
          (duplicateRow ? row : link).setAttribute('data-glgs-phone-redundant', '');
          return;
        }
        const labeledNumber = link.textContent.trim().match(/^(?:call|text)(?:\s+us)?[\s:]+([+\d().\s-]+)$/i);
        if (labeledNumber && numberFromText(labeledNumber[1]) === phone) link.textContent = phone.label;
        link.dataset.glgsPhoneChoice = 'true';
        link.setAttribute('role', 'button');
        link.setAttribute('aria-haspopup', 'dialog');
        link.setAttribute('aria-controls', dialog.id);
        link.setAttribute('aria-expanded', 'false');
        link.setAttribute('aria-label', `${link.getAttribute('aria-label') || link.textContent.trim()}. ${dialog.dataset.triggerLabel}`);
      });
    };
    const open = (link, event) => {
      const phone = businessNumber(link);
      if (dialog.open || !phone) return;
      dialog.querySelector('[data-glgs-phone-number]').textContent = phone.label;
      dialog.querySelector('[data-glgs-phone-call]').setAttribute('href', `tel:${phone.destination}`);
      dialog.querySelector('[data-glgs-phone-text]').setAttribute('href', `sms:${phone.destination}`);
      try { dialog.showModal(); } catch { return; }
      event.preventDefault();
      opener = link;
      link.setAttribute('aria-expanded', 'true');
      dialog.querySelector('[data-glgs-phone-call]').focus();
    };
    document.addEventListener('click', (event) => {
      const link = event.target.closest?.('a[data-glgs-phone-choice]');
      if (!link || event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
      open(link, event);
    });
    document.addEventListener('keydown', (event) => {
      const link = event.target.closest?.('a[data-glgs-phone-choice]');
      if (link && event.key === ' ' && !event.defaultPrevented && !event.repeat) open(link, event);
    });
    dialog.querySelector('[data-glgs-phone-close]').addEventListener('click', () => dialog.close());
    dialog.addEventListener('click', (event) => {
      if (event.target.closest?.('a[href]')) dialog.close();
      if (event.target !== dialog) return;
      const bounds = dialog.getBoundingClientRect();
      if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) dialog.close();
    });
    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && (dialog.open || suppressEscapeKeyup)) {
        suppressEscapeKeyup = true;
        event.stopPropagation();
      }
    }, true);
    document.addEventListener('keyup', (event) => {
      if (event.key === 'Escape' && suppressEscapeKeyup) {
        suppressEscapeKeyup = false;
        event.stopPropagation();
      }
    }, true);
    window.addEventListener('blur', () => { suppressEscapeKeyup = false; });
    dialog.addEventListener('close', () => {
      if (opener) {
        opener.setAttribute('aria-expanded', 'false');
        if (opener.isConnected) opener.focus({ preventScroll: true });
        opener = null;
      }
    });
    enhance(document);
    document.addEventListener('shopify:section:load', (event) => enhance(event.target));
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["glgs-signlab-buy-buttons"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('glgs-signlab-fields')) {
    customElements.define('glgs-signlab-fields', class extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        this.controller = new AbortController();
        const signal = this.controller.signal;
        const form = this.closest('form');
        const inputs = [...this.querySelectorAll('input[required]')];
        const checkInput = (input) => {
          input.setCustomValidity(input.value.trim() ? '' : this.dataset.requiredMessage);
        };
        inputs.forEach((input) => input.addEventListener('input', () => checkInput(input), { signal }));
        form.addEventListener('submit', (event) => {
          inputs.forEach(checkInput);
          if (!form.reportValidity()) {
            event.preventDefault();
            event.stopImmediatePropagation();
          }
        }, { capture: true, signal });
      }
      disconnectedCallback() {
        this.controller?.abort();
        this.controller = null;
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
